import React from 'react';
import SMORoomEditBaseFragment from './SMORoomEditBaseFragment';
import SMORoomEditMediaFragmentAttachmentsView from './SMORoomEditMediaFragmentAttachmentsView';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormLargeImageView from 'components/dashboard/form/SMFormLargeImageView';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMConst from 'lib/SMConst';

class SMORoomEditMediaFragment extends SMORoomEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      room: this.props.room,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      room : nextProps.room,
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  
  thumnailImageDidSelect(link, title) {
    this.showDialog(
      <SMFormLargeImageView imageUrl={link} title={title} delegate={this} />
    );
  }
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>写真<br />
          <span className="dashboard-title__supplement">
            ゲストが実際に利用するスペース、設備等の画像を最低1枚追加してください。推奨サイズは1260x840です。<br />
            ドラッグ＆ドロップで入れ替え可。クリックで拡大することができます。最大30枚まで追加できます。
          </span>
        </h2>
        <SMORoomEditMediaFragmentAttachmentsView items={this.props.room.attachments} delegate={this} errors={this.props.errors} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>動画
          <span className="dashboard-title__supplement ml15">
            YouTubeの動画を表示できます。動画は写真とともにスライドショー内に表示されます。
          </span>
        </h2>
        <SMFormTextFieldWithError name="embed_video_url" 
          value={this.state.room.embed_video_url} 
          errorText={SMFormatHelper.errorText('Room', 'embed_video_url', this.props.errors)}
          placeholderText="http://www.youtube.com/watch?v=XXXXXXXX" 
          options={{className:'w500'}}
          delegate={this} />

        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>
        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.RoomMedia} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}

SMORoomEditMediaFragment.defaultProps = {
  errors: [],
};
export default SMORoomEditMediaFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditMediaFragment.jsx